import React from 'react';

const ThemeContext = React.createContext<{ mode: 'content' | 'admin' }>({
  mode: 'content',
});

export default ThemeContext;
